import { CreditCardCriteria } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';

export const borrowerContactDetailsFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.4,
    field: 'borrower_contact_details',
    sortable: false,
    align: 'left',
    headerName: <Text tId={'CONTACT_DATA'} />,
    searchable: true,
    renderCell: (rowData: { row: CreditCardCriteria }) => (
      <>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            whiteSpace: 'break-spaces',
            lineHeight: '1.43',
            minWidth: 0,
          }}
        >
          <div className={'overflow-text-ellipsis'}>{rowData.row.customer.email}</div>
          <div className={'overflow-text-ellipsis'}>{rowData.row.customer.phoneNumber}</div>
        </div>
      </>
    ),
  };
};
